import { faMinus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MinusIcon } from '@heroicons/react/20/solid';
import React, { ReactNode } from 'react';
import { faPlus } from '../../../fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
/* eslint-disable */
export type HeaderCellProps = {
  title: string;
  isOrdering: boolean;
  children?: ReactNode;
  required: boolean;
  subHeader?: string;
  requiredPill?;
};

const HeaderCell: React.FC<HeaderCellProps> = props => {
  return (
    <th className="w-full flex px-4 py-3 text-xs leading-4 justify-between font-medium  tracking-wider">
      <div className={'flex flex-row items-start'}>
        <div className="text-left flex-col">
          <p className={'uppercase text-on-secondary-container '}>
            {props.title}
          </p>
          {props.subHeader !== undefined && (
            <div className={'mt-2 text-xs text-on-secondary-container '}>
              {props.subHeader}
            </div>
          )}
        </div>
        {props.required && props.requiredPill}
      </div>

      {props.isOrdering && (
        <div className="flex ">
          <FontAwesomeIcon
            icon={faMinus as IconProp}
            className={'text-on-secondary-container'}
          />
        </div>
      )}
      {!props.isOrdering && (
        <div className="flex">
          <FontAwesomeIcon
            icon={faPlus as IconProp}
            className={'text-on-secondary-container'}
          />
        </div>
      )}
    </th>
  );
};

export default HeaderCell;
export function RequiredPill() {
  return (
    <span
      className={`  bg-error-container rounded-full text-xs text-on-error-container uppercase px-2 ml-2`}
    >
      {'Required'}
    </span>
  );
}

export function RequiredMetPill() {
  return (
    <span
      className={`  bg-tertiary rounded-full text-xs text-on-tertiary uppercase px-2 ml-2`}
    >
      {'Selected'}
    </span>
  );
}
